export default {
  name: 'robotIcon',
  data: function () {
    return {
      machineTranslation: window.Granite.I18n.get('language.dropdown.machine.translation')
    };
  }
};